var exports = {
  "k": "xa15a2ab7--cc360f--container",
};

module.exports = exports;
